import { useState, useEffect } from 'react';
import { get } from '../Model/Network/Config/Axios';


export const useVendorContactHook = (id) => {
    const [loading, setLoading] = useState(true);
    const [tdsCertificates, setTdsCertificates] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (id) {
            reload();
        }
    }, [id]);

    const reload = () => {
        if (!id) {
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);
        
        get(`/vendor/contacts/${id}/details`, (e, r) => {
            if (r && r.config && r.config.tdsCertificates) {
                setTdsCertificates(r.config.tdsCertificates);
            } else if (e) {
                setError(e);
                setTdsCertificates(null);
            } else {
                setTdsCertificates(null);
            }
            setLoading(false);
        });
    };

    return {
        loading,
        tdsCertificates,
        error,
        reload
    };
}; 